import { render } from "./YoubeRiepilogoOrdini.vue?vue&type=template&id=c49776ea&scoped=true"
import script from "./YoubeRiepilogoOrdini.vue?vue&type=script&lang=js"
export * from "./YoubeRiepilogoOrdini.vue?vue&type=script&lang=js"

import "./YoubeRiepilogoOrdini.vue?vue&type=style&index=0&id=c49776ea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c49776ea"]])

export default __exports__